import React, { useEffect, useState } from "react";
import PdfViewer from "../../../../reusable_components/PdfViewer/PdfViewer";
import { UploadedFileViewerProps } from "./UploadedFileViewer.utils";
import WindowPortal from "../../../../reusable_components/WindowPortal/WindowPortal";

/**
 * UploadedFileViewer renders a PDF in a separate browser window via WindowPortal.
 * It delays rendering to prevent ResizeObserver errors from pdf-viewer.
 */
const UploadedFileViewer: React.FC<UploadedFileViewerProps> = ({
  preview,
  onClose,
}) => {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setDelayed(true), 100); // Let portal fully render first
    return () => clearTimeout(timer);
  }, []);

  if (!preview) return null;

  return (
    <WindowPortal title="File Viewer">
      {delayed && (
          <PdfViewer preview={preview} />
      )}
    </WindowPortal>
  );
};

export default UploadedFileViewer;
